import { useCallback, useMemo } from 'react'

import { PostsGroupHeaderDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import type { EmployeeSelectorV2MultiSelectState } from 'modules/employees/components/EmployeeSelectorV2/types'

type Props = {
  groupId: number
  onChange: (state: EmployeeSelectorV2MultiSelectState) => void
  disabled?: boolean
}

function InviteMembersView({ groupId, onChange, disabled }: Props) {
  const { data } = useQuery(PostsGroupHeaderDocument, {
    variables: { id: groupId },
  })

  const currentMemberIds = useMemo(() => {
    return data?.posts?.group?.employees?.map((employee) => employee.id) ?? []
  }, [data])

  const forcedFilters = useMemo(() => {
    return {
      excludeIds: currentMemberIds,
      excludeCurrentEmployee: true,
    }
  }, [currentMemberIds])

  const handleEmployeeChange = useCallback(
    (state: EmployeeSelectorV2MultiSelectState) => {
      onChange(state)
    },
    [onChange]
  )

  return (
    <EmployeeSelectorV2
      multiple
      onChange={handleEmployeeChange}
      forcedFilters={forcedFilters}
      disabled={disabled}
      options={{ disableSelectAll: false, asList: true, hideLabel: true }}
    />
  )
}

export default InviteMembersView
